import React from "react";
import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from "@mui/material";
import { AlertCircle } from "lucide-react";

interface ErrorModalProps {
  open: boolean;
  title?: string;
  message: string;
  onClose: () => void;
}

export default function ErrorModal({ open, title = "Error", message, onClose }: ErrorModalProps) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "12px",
          boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          alignItems: "flex-start",
          gap: "12px",
          paddingBottom: "0px",
        }}
      >
        <AlertCircle size={24} color="#ef4444" style={{ marginTop: "4px", flexShrink: 0 }} />
        <span style={{ fontSize: "18px", fontWeight: "600", color: "#1f2937" }}>{title}</span>
      </DialogTitle>
      <DialogContent sx={{ paddingTop: "24px", paddingBottom: "24px" }}>
        <p style={{ margin: 0, fontSize: "16px", color: "#4b5563", lineHeight: "1.5" }}>
          {message}
        </p>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 24px", borderTop: "1px solid #e5e7eb" }}>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            backgroundColor: "#ef4444",
            color: "white",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: "600",
            padding: "8px 24px",
            borderRadius: "8px",
            "&:hover": {
              backgroundColor: "#dc2626",
            },
          }}
        >
          Aceptar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
